import {
  AnnotationBase,
  AnnotationPluginState,
  AnnotationSelectionState,
  ToolMessage,
  ToolStateBase
} from './types'
import { AnnotationPlugin } from '../../annotation-plugin'
import { PageStructure } from '../../models'

type AnnotationLayerModel = {
  annotations: AnnotationBase[]
  toolState: ToolStateBase
  activeAnnotation: AnnotationBase | undefined
  selectionState: AnnotationSelectionState
  tools: AnnotationPlugin<AnnotationBase, ToolStateBase>[]
}

export function AnnotationLayerOverlay({
  model,
  page,
  send,
  renderToolOverlay
}: {
  model: AnnotationLayerModel
  page: PageStructure
  send: (message: ToolMessage<AnnotationBase, ToolStateBase>) => void
  renderToolOverlay: boolean
}) {
  return (
    <>
      {model.tools.flatMap((tool) => {
        if (!renderToolOverlay) return []
        if (!tool.ToolOverlay || model.toolState.name != tool.name) return []
        const ToolOverlay = tool.ToolOverlay
        return (
          <ToolOverlay
            key={tool.name}
            page={page}
            toolState={model.toolState}
            activeAnnotation={model.activeAnnotation}
            status={resolveActiveAnnotationStatus(model.selectionState, model.activeAnnotation)}
            send={send}
          />
        )
      })}

      {model.annotations.map((annotation) => {
        const matchingPlugin = model.tools.find((tool) => tool.handlesAnnotation?.(annotation))

        const Element = matchingPlugin?.Element
        if (!Element) return null

        return (
          <Element
            key={annotation.id}
            annotation={annotation}
            page={page}
            status={resolveAnnotationStatus(model.selectionState, annotation.id)}
            send={send}
          />
        )
      })}
    </>
  )
}

function resolveActiveAnnotationStatus(
  selectionState: AnnotationPluginState['selectionState'],
  activeAnnotation: AnnotationBase | undefined
): AnnotationPluginState['selectionState']['type'] {
  if (!activeAnnotation) return 'none'
  if (selectionState.type == 'none') return 'none'
  if (selectionState.annotationId !== activeAnnotation.id) return 'none'
  return selectionState.type
}

function resolveAnnotationStatus(
  selectionState: AnnotationPluginState['selectionState'],
  annotationId: string
): AnnotationPluginState['selectionState']['type'] {
  if (selectionState.type == 'none') return 'none'
  if (selectionState.annotationId != annotationId) return 'none'
  return selectionState.type
}
